module.exports = __webpack_public_path__ + "img/07.56f705fa.png";